import React from 'react';
import { BellIcon, LinkIcon, TagIcon } from '../components/icons';
import { cx } from '../components/styles';
import { CONTAINER, SECTION_PADDING } from './landingConfig';
import { Reveal } from './Reveal';

/** Section 4. The pain, reframed in the buyer's words. */
const OUTCOMES = [
  {
    title: 'Alerts, not refreshing',
    body: 'Follow the venues and promoters you sell for. We email you when they put a show on sale.',
    Icon: BellIcon,
  },
  {
    title: 'Every account at once',
    body: 'Join a waitlist or send tickets across all your connected accounts in one action.',
    Icon: LinkIcon,
  },
  {
    title: 'One price, everywhere',
    body: 'Change a price in FlashTools and your CrowdVolt listing follows.',
    Icon: TagIcon,
  },
];

export const OutcomeRow: React.FC = () => (
  <Reveal as="section" className={SECTION_PADDING}>
    <div className={CONTAINER}>
      <h2 className="text-3xl font-bold tracking-tight text-white">Stop juggling logins.</h2>
      <div className="mt-10 grid gap-6 md:grid-cols-3">
        {OUTCOMES.map(({ title, body, Icon }) => (
          <div
            key={title}
            className={cx(
              'rounded-2xl border border-white/[0.06] bg-white/[0.02] p-6',
              'transition-colors hover:border-white/[0.10]',
            )}
          >
            <div className="flex h-10 w-10 items-center justify-center rounded-lg border border-[#3b82f6]/25 bg-[#3b82f6]/10 text-[#60a5fa]">
              <Icon className="h-5 w-5" />
            </div>
            <p className="mt-4 text-base font-semibold text-white">{title}</p>
            <p className="mt-2 text-sm leading-relaxed text-white/60">{body}</p>
          </div>
        ))}
      </div>
    </div>
  </Reveal>
);
